import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { getCandidateReminderListURL } from '../constants';
import { getTitle } from '../utils/utilFunctions';

import ReminderList from './ReminderList';
import { getCandidateReminderList } from './api/candidateReminderAPI';

const CandidatesRemindersPage = ({ handleSnackbarOpen, liftUpStateToApp, errorHandling }) => {
  const [reminders, setReminders] = useState([]);

  const loadReminders = useCallback(async () => {
    try {
      const data = await getCandidateReminderList();
      setReminders(data);
    } catch (err) {
      errorHandling(err, getCandidateReminderListURL);
    }
  }, [errorHandling]);

  useEffect(() => {
    document.title = `Wiedervorlagen Kandidaten - ${getTitle()}`;
    loadReminders();
  }, [loadReminders]);

  const sortedReminders = useMemo(() => [...reminders].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)), [reminders]);

  return (
    <div className="container  h-100-minusAppBar" key="maincontainer">
      <div className="row align-items-center h-100">
        <div className="col-12 pt-3">
          <ReminderList
            reminders={sortedReminders}
            variant="candidate"
            timeSeparation
            handleSnackbarOpen={handleSnackbarOpen}
            onIsReadButtonClick={loadReminders}
            onDeleteButtonClick={loadReminders}
            onEditButtonClick={loadReminders}
            onRowClick={liftUpStateToApp}
            errorHandling={errorHandling}
          />
        </div>
      </div>
    </div>
  );
};

CandidatesRemindersPage.propTypes = {
  handleSnackbarOpen: PropTypes.func.isRequired,
  liftUpStateToApp: PropTypes.func.isRequired,
  errorHandling: PropTypes.func.isRequired
};

export default CandidatesRemindersPage;
